export const graphTooltips = [
  {
    key: "Conversion Rate",
    value:
      "Percent of unique site visitors that placed an order through the online store.",
  },
  {
    key: "Revenue per Site Visitor",
    value:
      "Total revenue divided by number of unique site visitors. Revenue includes product and shipping revenue, net of discounts.",
  },
  {
    key: "Profit per Site Visitor",
    value:
      "Total profit divided by number of unique site visitors. Profit includes product and shipping revenue, net of discounts, COGS and cost of shipping.",
  },
  {
    key: "Visitors",
    value: "Number of unique site visitors included in the test.",
  },
  {
    key: "Orders",
    value: "Number of orders placed on the site.",
  },
  {
    key: "Product Revenue per Order",
    value:
      "Average revenue per order generated by product sales alone (i.e. excludes shipping charges).",
  },
  {
    key: "Shipping Revenue per Order",
    value: "Average revenue per order generated by shipping charges.",
  },
  {
    key: "AOV",
    value:
      "Average order value, including revenue generated from product sales and shipping charges.",
  },
  {
    key: "Subscription AOV",
    value:
      "Average order value for first subscription orders, split by revenue generated from product sales (Product Revenue per Order) and shipping charges (Shipping Revenue per Order).",
  },
  {
    key: "Average Units per Order",
    value: "Average quantity of product units contained in each order.",
  },
  {
    key: "Subscription Average Units per Order",
    value:
      "Average quantity of subscription product units contained in each order.",
  },
  {
    key: "Average Product Revenue per Unit",
    value:
      "Average selling price for a single unit. Equals average product revenue per order divided by average units per order.",
  },
  {
    key: "Subscription Product Revenue per Unit",
    value:
      "Average selling price for a single subscription unit. Equals average product revenue per order divided by subscription average units per order.",
  },
  {
    key: "Gross Margin",
    value: "Total profit divided by total revenue.",
  },
  {
    key: "Percent of Orders with Free Shipping",
    value: "Percentage of all orders that had no associated shipping revenue",
  },
  {
    key: "AOV Breakdown",
    value:
      "Average order value, split by revenue generated from product sales (Product Revenue per Order) and shipping charges (Shipping Revenue per Order).",
  },
  {
    key: "Order Value Histogram",
    value: "Distribution of orders by order value (in increments of $10).",
  },
  {
    key: "Orders over Time",
    value: "Number of orders placed on the site, by day.",
  },
  {
    key: "Views over Time",
    value:
      "Number of visitors included in the test, by day. If a user returns to the site over multiple days, only their first visit is reflected.",
  },
  {
    key: "Orders / Percent Total Orders",
    value:
      "Number of orders with discount applied / percentage of all orders in test group, subject to other filters.",
  },
  {
    key: "Average Offer per Order",
    value:
      "Average discount per order (includes only orders with applicable discount).",
  },
  {
    key: "% of AOV (Discounted Orders)",
    value:
      "Average discount per order as percentage of average order value for orders with applicable discount applied.",
  },
  {
    key: "% of PPO (Discounted Orders)",
    value:
      "Average discount per order as percentage of profit per order for orders with applicable discount applied.",
  },
  {
    key: "% of AOV (All Orders)",
    value:
      "Average discount per order as percentage of average order value for all orders in test group, subject to other filters.",
  },
  {
    key: "% of PPO (All Orders)",
    value:
      "Average discount per order as percentage of profit per order for all orders in test group, subject to other filters.",
  },
  {
    key: "% Orders by Unit Quantity",
    value:
      "Breakdown of orders by the quantity of units contained in each order.",
  },
  {
    key: "% Net Revenue by Order Unit Quantity",
    value:
      "Breakdown of net revenue by the quantity of units contained in each order.",
  },
  {
    key: "Unit Quantity Histogram",
    value: "Distribution of orders by quantity of units contained.",
  },
  {
    key: "Offer Histogram",
    value: "Distribution of orders by total discount, in increments of $10.",
  },
  {
    key: "% of Gross Revenue (pre-discount)",
    value:
      "Offer total as a percentage of total gross revenue (pre-discount) for orders containing discounts (‘Discounted Orders’) and all orders (‘All Orders’), subject to other filters.",
  },
  {
    key: "% of Gross Profit (pre-discount)",
    value:
      "Offer total as a percentage of total gross profit (pre-discount) for orders containing discounts (‘Discounted Orders’) and all orders (‘All Orders’), subject to other filters.",
  },
  {
    key: "Revenue by Product Group",
    value:
      "Breakdown of product revenue into product group. Revenue is net of discounts and excludes shipping.",
  },
  {
    key: "Units by Product Group",
    value: "Breakdown of units sold into product group.",
  },
  {
    key: "Units Sold",
    value: "Number of units sold for products in the selected product group.",
  },
  {
    key: "Revenue per Visitor",
    value:
      "Revenue for products in the selected product group divided by number of unique site visitors. Includes product revenue only, net of discounts (excludes shipping).",
  },
  {
    key: "Profit per Visitor",
    value:
      "Profit for products in the selected product group divided by number of unique site visitors. Includes product revenue only, net of discounts and product COGS (excludes shipping).",
  },
  {
    key: "% Total Units",
    value:
      "Number of units sold for products in the selected product group divided by total number of units sold for all product types.",
  },
  {
    key: "Revenue per Unit",
    value:
      "Revenue divided by number of units sold for products in the selected product group. Includes product revenue only, net of discounts (excludes shipping).",
  },
  {
    key: "Profit per Unit",
    value:
      "Profit divided by number of units sold for products in the selected product group. Includes product revenue only, net of discounts and product COGS (excludes shipping).",
  },
  {
    key: "Average Units Ordered",
    value:
      "Number of units sold for products in the selected product group divided by number of orders containing any item in the product group.",
  },
  {
    key: "Average Units per Visitor",
    value:
      "Number of units sold for products in the selected product group divided by number of unique site visitors.",
  },
  {
    key: "Orders Discounted",
    value: "Number of orders placed on the site that received a discount.",
  },
  {
    key: "Percent Orders Discounted",
    value: "Percent of orders placed that include a discount.",
  },
  {
    key: "Offer % of Revenue (pre-discount)",
    value: "Offer total as a percentage of total gross revenue (pre-discount).",
  },
  {
    key: "Offer % of Profit (pre-discount)",
    value: "Offer total as a percentage of total gross profit (pre-discount).",
  },
  {
    key: "Average Offer",
    value:
      "Average discount per order (includes all orders, regardless of whether discounts were applied).",
  },
  {
    key: "Total Revenue",
    value: "Includes product and shipping revenue, net of discounts.",
  },
  {
    key: "Total Profit",
    value:
      "Includes product and shipping revenue, net of discounts, product COGS, shipping COGS and transaction fees.",
  },
  {
    key: "Total Offer Offered",
    value:
      "Includes product discounts (delta between list and net price) and shipping discounts.",
  },
  {
    key: "Subscription % of Orders",
    value:
      "Percentage of orders that contained a subscription. Only subscription first orders are counted, automatic refill orders are excluded.",
  },

  {
    key: "Subscription Conversion Rate",
    value:
      "Number of new subscription orders divided by number of unique site visitors.",
  },
  {
    key: "Subscription Revenue per Visitor",
    value:
      "Total revenue from new subscription orders divided by number of unique site visitors. Revenue includes both product and shipping revenue, net of discounts.",
  },
  {
    key: "Subscription Profit per Visitor",
    value:
      "Total profit from new subscription orders divided by number of unique site visitors. Profit includes product and shipping revenue, net of discounts, COGS, and cost of shipping.",
  },
];
